import Input, { IProps as IInputProps, IFinalFormFieldInputComponentProps, FieldRenderProps } from './Input';
import inputStyles from './input.module.scss';

export type InputRef = InstanceType<typeof Input>;

export { Input, inputStyles };
export type { IInputProps, IFinalFormFieldInputComponentProps, FieldRenderProps };
export type { InputSize } from './types';

export default Input;
